export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 7.0a2e2468.png";